import { IInvitationType } from 'core/types/referral.interface';

export interface IAvatar {
  id: number;
  name: string;
  image: string;
  level: number;
}

export interface IUserLanguage {
  available_for_ui: boolean;
  code: 'es' | 'en';
  id: number;
  name: string;
  name_localized: string;
}

export interface IUserParent {
  id?: number;
  full_name?: string;
  email?: string;
}

export interface ITimezone {
  id?: number;
  name?: string;
  iso_name?: string;
  localizable_name?: string;
  offset?: number;
}

export interface ICountry {
  id?: number;
  name_en?: string;
  name_es?: string;
  code?: string;
  phone_code?: string;
  localizable_name?: string;
}

export interface IState {
  id?: number;
  name_en?: string;
  name_es?: string;
  code?: string;
  phone_code?: string;
  localizable_name?: string;
}

export interface IContactMethodType {
  id?: number;
  name?: string;
  localizable_name?: string;
}

export interface IUserType {
  id?: number;
  code?: string;
  name?: string;
}

export interface ILevel {
  id?: number;
  name?: string;
  level?: number;
  end_balance: string;
  start_balance: string;
  /**/
  leaves?: number;
  /**/
}

export interface IPhoneNumberCountry {
  code: string;
  id: number;
  localizable_name: string;
  name_en: string;
  name_es: string;
  phone_code: string;
}

export interface IOkeeyCashAccountNumberStatus {
  id: number;
  name: string;
  code: string;
  localizable_name: string;
}

export enum MilestoneUserTypeCode {
  SEED = 'SEED',
  GANACUATE = 'GC',
  GANARBOL = 'GR',
  GANASOCIO = 'GS'
}

export interface IMilestoneTimeline {
  change_date: string;
  user_type_code: MilestoneUserTypeCode;
  user_type_name: string;
}

export interface IReferredBy {
  id: number;
  email?: string;
  full_name: string;
  referral_code?: string;
  user_type?: string;
  is_self?: boolean;
}

export interface ICommunityBreakdown {
  total_community_size: number;
  breakdown: {
    ganarbols: number;
    ganacuates: number;
    ganasocios: number;
  };
  weekly_growth: {
    change: number;
    is_growing: boolean;
  };
}

export interface IDashboardStats {
  invitations_sent: number;
  avg_card_spending: number;
  new_activations: number;
}

export interface IUser {
  id?: number;
  is_deleted?: boolean;
  public_id?: string;
  email?: string;
  address?: string;
  state?: IState;
  city?: string | null;
  gender?: string | null;
  phone_number_country?: IPhoneNumberCountry;
  milestone_timeline?: IMilestoneTimeline[];
  total_gana_arboles?: number;
  total_gana_cuates?: number;
  phone_number?: string;
  avatar?: IAvatar;
  avatar_id?: number;
  first_name?: string;
  last_name?: string;
  contract_terms?: string | null;
  contract_date?: string | null;
  contact_person?: string | null;
  user_parent?: IUserParent;
  user_partner?: IUserParent;
  user_recruiter?: IUserParent;
  user_coordinator?: IUserParent;
  full_name?: string | null;
  timezone?: ITimezone;
  country?: ICountry;
  contact_method_type?: IContactMethodType;
  balance?: string;
  potential_balance?: string;
  total_earned_balance?: string;
  total_spent_balance?: string;
  referral_code?: string;
  user_type?: IUserType;
  level?: ILevel;
  is_visible?: boolean;
  is_eligible?: boolean;
  okeey_cash_internal_user_id?: number;
  total_ganarbols?: number;
  banked_eligibility?: number;
  status?: string;
  branches?: number;
  leaves?: number;
  rings?: number;
  user_language?: IUserLanguage;
  street_address?: string;
  ganamigos_since?: string;
  zip_code?: string;
  profile_color?: string;
  total_referrals?: number;
  spent_money?: number;
  reward_based?: number;
  current_commission?: number;
  pending_payments?: number;
  paid_earnings?: number;
  okeey_cash_account_number_status?: IOkeeyCashAccountNumberStatus | null;
  total_network_size?: number;
  direct_recruits?: number;
  money_balance?: string;
  current_month_money_balance?: string;
  next_payment_money_amount?: string;
  referred_by?: IReferredBy | string | null;
  invitation_type?: IInvitationType;
  partner_promo_fund_balance?: number;
  location?: string;
  earnings?: {
    lifetime_earnings: number;
    monthly_earnings: {
      month: string; // "2025-11"
      amount: number;
      transaction_count: number;
    }[];
    current_month_change: {
      amount: number;
      display_text: string;
      is_growing: boolean;
      percentage: number;
    };
  };
  community_breakdown?: ICommunityBreakdown;
  dashboard_stats?: IDashboardStats;
  is_direct_referral?: boolean;
}
